export enum QuoteDocumentFillingTypeEnum{
    Manually = 1,
    Automatically,
    ThirdParty
}